import ReactGA from 'react-ga4';
import config from 'config/config';

class Analytics {
  private isInitialized = false;
  private isEnabled = config.googleAnalytics.enabled;
  private trackingId = config.googleAnalytics.trackingId;

  init() {
    if (!this.isInitialized && this.trackingId) {
      ReactGA.initialize(this.trackingId);
      this.isInitialized = true;
    }
  }

  trackLogin(userId: string) {
    if (this.isInitialized) {
      ReactGA.gtag('event', 'login', {
        moenId: userId
      });
    }
  }

  trackCriticalResolve(moenId: string) {
    if (this.isInitialized) {
      ReactGA.gtag('event', 'critical_alert_resolve', {
        moenId: moenId
      });
    }
  }

  trackValveAction(moenId: string) {
    if (this.isInitialized) {
      ReactGA.gtag('event', 'valve_action', {
        moenId: moenId
      });
    }
  }

  trackAlertSleepAction(hours: number, moenId: string, alertId: string) {
    if (this.isInitialized) {
      ReactGA.gtag('event', 'alert_sleep_action', {
        hours: hours,
        moenId: moenId,
        alertId: alertId,
      });
    }
  }

  trackThresholdUpdate(moenId: string, locationType: string) {
    if (this.isInitialized) {
      ReactGA.gtag('event', 'threshold_update', {
        moenId: moenId,
        locationType: locationType
      })
    }
  }

  trackUserAdded(moenId: string) {
    if (this.isInitialized) {
      ReactGA.gtag('event', 'user_added', {
        moenId: moenId
      });
    }
  }

  trackUserRemoved(moenId: string) {
    if (this.isInitialized) {
      ReactGA.gtag('event', 'user_removed', {
        moenId: moenId
      });
    }
  }

  trackUserUpdated(moenId: string) {
    if (this.isInitialized) {
      ReactGA.gtag('event', 'user_updated', {
        moenId: moenId
      });
    }
  }
}

export const analytics = new Analytics();
